// Trusted Types "default" ilkesi: CSP'deki require-trusted-types-for 'script' ile DOM'daki betik havuzlarına
// (script.src, setAttribute("src"), innerHTML …) düz metin yazılınca tarayıcı bu ilkeyi çağırır.
// İki yerden kurulur (hangisi önce çalışırsa; ikincisi hiçbir şey yapmaz): kök düzenin <head>'indeki nonce'lu satır içi
// betik (src/app/[lang]/layout.tsx; en erken) ve src/instrumentation-client.ts (Next'in istemci girişi, hidrasyondan önce).
// İkincisi gerekli: sunucu çizimi hata/404 kabuğuna düşerse (<html id="__next_error__">) Next kök düzenin <head>'ini
// göndermez, sayfa tarayıcıda baştan çizilir ve parça yükleyici ilke olmadan engellenirdi. Next.js (Turbopack
// parça yükleyicisi), React ve gtag.js Trusted Types nesnesi üretmediği için bu ilke olmadan site çalışmazdı.
//
//  - createScriptURL: yalnızca kendi kökenimizin /_next/ altı (derleme parçaları) ve Google etiket betiği
//    (www.googletagmanager.com; analitik onayı verilince). Başka her adres reddedilir (betik yüklenmez, CSP ihlali).
//    'strict-dynamic' betik kaynağında alan adı listesini yok saydığı için asıl izin listesi budur.
//  - createScript: yok → satır içi betik metni (eval benzeri kullanım) her zaman reddedilir.
//  - createHTML: metni olduğu gibi geçirir. HTML havuzlarını yalnızca React kullanır (istemci gezintisinde
//    dangerouslySetInnerHTML): içerik sunucuda sanitize-html ile temizlenmiş zengin metin, JSON-LD ve tema CSS'i
//    (src/lib/utils/html.ts). Sitenin kendi istemci kodunda innerHTML/insertAdjacentHTML yok (birim testi denetler).
// Ayrıntı: docs/security-headers.md

/** Tarayıcıda çalışan ilke (test için ayrı fonksiyon; sayfaya TRUSTED_TYPES_SCRIPT olarak yazılır) */
export function installTrustedTypesPolicy(win: { trustedTypes?: unknown; location: { href: string; origin: string } }, scriptOrigins: string[]): void {
  const tt = win.trustedTypes as
    | { createPolicy?: (name: string, rules: Record<string, (s: string) => string | null>) => unknown; defaultPolicy?: unknown }
    | undefined;
  if (!tt || typeof tt.createPolicy !== "function" || tt.defaultPolicy) return;
  try {
    tt.createPolicy("default", {
      createHTML: (s: string) => s,
      createScriptURL: (s: string) => {
        let u: URL;
        try {
          u = new URL(s, win.location.href);
        } catch {
          return null;
        }
        if (u.protocol !== "https:" && u.protocol !== "http:") return null;
        if (u.origin === win.location.origin) return u.pathname.startsWith("/_next/") ? s : null;
        return scriptOrigins.includes(u.origin) ? s : null;
      },
    });
  } catch {
    // İlke zaten tanımlı (aynı belgede ikinci kez çalıştı): ilki geçerli
  }
}

/** <head> içine yazılan satır içi betik (derlemeden bağımsız, küçültülmüş: ~0,5 KB) */
export function trustedTypesScript(scriptOrigins: string[]): string {
  return `(${installTrustedTypesPolicy.toString()})(window,${JSON.stringify(scriptOrigins)});`;
}
